<template>
  <span>
    <v-container v-if="datos" class="margen_paginas pt-7" fluid>
      <!-- configuracion -->
      <v-row dense>
        <v-col cols="12" lg="6">
          <v-card class="tarjeta" >
            <h4 class="mb-3">Configuración</h4>
            <v-row dense>
              <v-col cols="3" class="body-2">APP Id:</v-col>
              <v-col class="vc">{{appId}}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="body-2">URL base Frontend:</v-col>
              <v-col class="vc">{{urlBaseFrontend}}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="body-2">URL base Backend:</v-col>
              <v-col class="vc">{{urlBaseBackend}}</v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- base de datos -->
        <v-col cols="12" lg="6">
          <v-card class="tarjeta" >
            <h4 class="mb-3">Base de datos</h4>
            <v-row dense>
              <v-col cols="3" class="body-2">Servidor:</v-col>
              <v-col class="vc">{{datos.bd.servidor}}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="body-2">Nombre:</v-col>
              <v-col class="vc">{{datos.bd.nombre}}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="body-2">Versión MySQL: </v-col>
              <v-col class="vc">{{datos.bd.version_mysql}}</v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- servicios -->
        <v-col cols="12" lg="6">
          <v-card class="tarjeta" >
            <h4 class="mb-3">Servicios</h4>
            <v-row dense>
              <v-col cols="3" class="body-2">SAGA Broker:</v-col>
              <v-col class="vc">
                <span v-if="datos.servicios.saga_broker">
                  <div>{{datos.servicios.saga_broker.url}}</div>
                  <div>{{datos.servicios.saga_broker.version}} ({{datos.servicios.saga_broker.date}})</div>
                  <div>{{datos.servicios.saga_broker.module}}</div>
                </span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="body-2">API de cálculo de tarifas:</v-col>
              <v-col class="vc">
                <span v-if="datos.servicios.api_calculo_tarifas">
                  <div>{{datos.servicios.api_calculo_tarifas.url}}</div>
                  <div>{{datos.servicios.api_calculo_tarifas.version}} ({{datos.servicios.api_calculo_tarifas.date}})</div>
                  <div>{{datos.servicios.api_calculo_tarifas.module}}</div>
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- PHP -->
        <v-col cols="12" lg="6">
          <v-card class="tarjeta" >
            <h4 class="mb-3">PHP</h4>
            <v-row dense>
              <v-col cols="3" class="body-2">Versión:</v-col>
              <v-col class="vc">{{datos.php.version}}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="body-2">Sistema operativo:</v-col>
              <v-col class="vc">{{datos.php.so}}</v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- SAGA broker -->
        <v-col cols="12" lg="6">
          <v-card class="tarjeta" >
            <h4 class="mb-3">Conexiones</h4>
            <v-row dense>
              <v-col cols="3" class="body-2"><v-badge inline :content="clientes_web.length" color="#9CCC65"><span>Web:</span></v-badge></v-col>
              <v-col class="vc">
                <span v-if="datos.saga_broker">
                  <div v-for="(cliente, i) in clientes_web" :key="i">{{cliente.id}} ({{cliente.extremo_remoto}})</div>
                </span>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="body-2"><v-badge inline :content="clientes_aparcamientos.length" color="#64B5F6"><span>Aparcamientos:</span></v-badge></v-col>
              <v-col class="vc">
                <span v-if="datos.saga_broker">
                  <div v-for="(cliente, i) in clientes_aparcamientos" :key="i">{{cliente.nombre_instalacion_SAGA}} ~ {{cliente.version}} ({{cliente.extremo_remoto}})</div>
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- <pre style="background: #fff">{{datos}}</pre> -->
    </v-container>
    <v-progress-linear v-else
      color="red"
      indeterminate>
    </v-progress-linear>
  </span>
</template>

<script>
import api from "@/api"

export default {
  data() {
    return {
      appId: process.env.VUE_APP_ID,
      appVersion: process.env.VUE_APP_VERSION,
      urlBaseFrontend: process.env.VUE_APP_URL_BASE_FRONTEND,
      urlBaseBackend: process.env.VUE_APP_URL_BASE_BACKEND,
      datos: null,
    }
  },
  computed: {
    clientes_web () {
      if (this.datos && this.datos.saga_broker && this.datos.saga_broker.clientes)
        return this.datos.saga_broker.clientes.filter (cliente => cliente.userAgent);
      else
        return [];
    },
    clientes_aparcamientos () {
      if (this.datos && this.datos.saga_broker && this.datos.saga_broker.clientes)
        return this.datos.saga_broker.clientes.filter (cliente => cliente.id_instalacion);
      else
        return [];
    }
  },
  created() {
    api.obtenerInformacionEstadoSistema()
      .then ((respuesta) => {
        this.datos = respuesta.data;
      });
  }
};
</script>

<style scoped>
.tarjeta {
  padding: 12px;
  margin-right: 12px;
  margin-bottom: 6px;
}
.vc {
  background-color: #eeeee5;
  margin-bottom: 4px;
  border-radius: 8px;
  font-size: 14px;
  font-family: monospace;
  word-break: break-all;
}
</style>